import { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from '../../../Components/Button/Button';
import { EnumCalzada } from '../../../Utils/Enumeradores/ComunEnum';

const ModalConsolidacion = ({ onHide, todosElementos, elemento, nombreModal, setTablaDatos, tablaDatos, isElemento, data, cambiarFecha, setHayCambiosModal, seleccionInicialRef, ...rest }) => { 
  const [seleccionTodo, setSeleccionTodo] = useState(true);
  const [elementosTemporalmenteMarcados, setElementosTemporalmenteMarcados] = useState({});

  useEffect(() => {
    const elementosGuardados = JSON.parse(localStorage.getItem('elementosMarcados')) || {};
    const elementosIniciales = data.reduce((acumulador, fila) => {
      const id = elemento ? fila.idBIM : fila.matrizHectometroId;
      acumulador[id] = elementosGuardados[id] ?? true;
      return acumulador;
    }, {});
    setElementosTemporalmenteMarcados(elementosIniciales);
  }, [data, elemento]);

  const manejarSeleccionTodo = () => {
    const nuevaSeleccionTodo = !seleccionTodo;
    setSeleccionTodo(nuevaSeleccionTodo);
    setElementosTemporalmenteMarcados(prev => 
      Object.keys(prev).reduce((acumulador, id) => {
        acumulador[id] = nuevaSeleccionTodo;
        return acumulador;
      }, {})
    );
  };

  const manejarCambio = (id) => {
    setElementosTemporalmenteMarcados(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const manejarConfirmar = () => {
    const seleccionActual = Object.keys(elementosTemporalmenteMarcados).filter(id => elementosTemporalmenteMarcados[id]);
    const hayDiferencias = JSON.stringify(seleccionInicialRef.current.sort()) !== JSON.stringify(seleccionActual.sort());

    setHayCambiosModal(hayDiferencias);

    localStorage.setItem('elementosMarcados', JSON.stringify(elementosTemporalmenteMarcados));
    setTablaDatos(prevTablaDatos =>
      prevTablaDatos.map(fila => {
        if (isElemento && fila.planElementos) {
          return {
            ...fila,
            planElementos: fila.planElementos.map(elemento => ({
              ...elemento,
              estado: elementosTemporalmenteMarcados[elemento.idBIM] ?? false
            }))
          };
        } else if (!isElemento && fila.planHectometros) {
          return {
            ...fila,
            planHectometros: fila.planHectometros.map(hectometro => ({
              ...hectometro,
              estado: elementosTemporalmenteMarcados[hectometro.matrizHectometroId] ?? false
            }))
          };
        }
        return fila;
      })
    );
    onHide();
  };

  const manejarCerrar = () => {
    setElementosTemporalmenteMarcados(prev => ({ ...prev }));
    onHide();
  };

  useEffect(() => {
    if (rest.show) {
      if (seleccionInicialRef.current === null) {
        seleccionInicialRef.current = tablaDatos
          .flatMap(fila => isElemento ? fila.planElementos : fila.planHectometros)
          .filter(dato => dato.estado)
          .map(dato => isElemento ? dato.idBIM : dato.matrizHectometroId);
      }
    }
  }, [rest.show]);
  
  return (
    <Modal {...rest} size="lg" centered keyboard={false}>
      <Modal.Header>
        <h5 className="modal-title">
          <span>{elemento ? 'Elementos' : 'Hectómetros'} Involucrados</span>
          <br />
          {nombreModal && <span className="modal-subtitle">{nombreModal}</span>}
        </h5>
        <Button
          type="button"
          design="btn-outline-pewter-blue p-2 lh-1 fs-3"
          onClick={manejarCerrar}
        >
          <i className="ico-close"></i>
        </Button>
      </Modal.Header>

      <Modal.Body className="p-4 gap-4 d-flex flex-column">
        <div
          className="accordion-body p-0 brd-top"
          style={{
            maxHeight: '235px',
            overflowY: 'scroll',
            border: '1px solid #ddd',
            scrollbarWidth: 'thin',
            scrollbarColor: '#ddd #fff',
          }}
        >
          <table
            className="table table-sm"
            border="1"
            style={{ width: '100%', textAlign: 'left', marginBottom: '0' }}
          >
            <thead>
              <tr> 
              {cambiarFecha === false &&              
                  <th>
                    <input
                      type="checkbox"
                      checked={seleccionTodo}
                      onChange={manejarSeleccionTodo}
                    />
                  </th>
              }
                <th>{elemento ? 'IdBIM' : 'Hectómetro'}</th>
                <th>{elemento ? 'Descripción' : 'Km Inicial Hectómetro'}</th>
                <th>{elemento ? 'Km Elemento' : 'Km Final Hectómetro'}</th>
                {elemento && <th>Calzada</th>}
                <th>Macroubicacion</th>
              </tr>
            </thead>
            <tbody>    
            {data.map((row, index) => {
                const id = elemento ? row.idBIM : row.matrizHectometroId;
                return (
                  <tr key={index}>
                    {cambiarFecha === false && 
                      <td>
                        <input
                          type="checkbox"
                          checked={elementosTemporalmenteMarcados[id] || false}
                          onChange={() => manejarCambio(id)}
                        />
                      </td>
                    }
                    <td>{elemento ? row.idBIM : row.hectometro}</td>
                    <td>{elemento ? row.descripcion : row.pkInicialHectometro}</td>
                    <td>{elemento ? row.kmElemento : row.pkFinalHectometro}</td>
                    {elemento && <td>{EnumCalzada[row.calzada]}</td>}
                    <td>{row.macroubicacionMostrar}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
          <div className="d-flex justify-content-center align-items-center">
          {cambiarFecha === false ? (
            <button onClick={manejarConfirmar} className="btn btn-primary">
              Confirmar Seleccion
            </button>
          ) : (
            <button onClick={onHide} className="btn btn-primary">
              Cerrar
            </button>
          )}
          </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalConsolidacion;